import { Grid, Typography } from "@mui/material";
import Cono_Gratis from "./Componentes/Cono_Gratis";
import { useResponsive } from "../../Modulo_Responsive/Hooks/useResponsive";
import ListaClientes from "./Componentes/SubComponentes/ListaClientes";
import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import { collection, onSnapshot, doc } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import Pista_Cono from "./Componentes/SubComponentes/Pista_Cono";

const Seccion_Cono_Gratis = () => {
    const { sCell } = useResponsive();
    const [urlsTituloClientes, setUrlsTituloClientes] = useState([]);
    const [textos, setTextos] = useState({});

    useEffect(() => {
        const unsub1 = onSnapshot(collection(db, "cono-titulo-clientes"), (snap) => {
            const docs = snap.docs.map(d => ({ id: d.id, ...d.data() }));
            docs.sort((a, b) => {
                if (a.orden !== undefined && b.orden !== undefined) return a.orden - b.orden;
                if (a.numero !== undefined && b.numero !== undefined) return a.numero - b.numero;
                return 0;
            });
            setUrlsTituloClientes(docs.map(d => d.url).filter(Boolean));
        });

        const unsub2 = onSnapshot(doc(db, "configuracion", "textos"), (snap) => {
            if (snap.exists()) setTextos(snap.data());
        });

        return () => { unsub1(); unsub2(); };
    }, []);

    return (
        <>
            <Helmet>
                <title>Cono gratis | Toppings</title>
                <meta name="description" content="Aprovecha la promoción de cono gratis en Toppings Colón. Deliciosos helados con los mejores toppings para ti." />
                <meta name="keywords" content="cono gratis en Colón, promoción helados Colón, helados gratis en Colón, helados con toppings, ofertas en helados Colón, postres en Colón, heladerías en Colón" />
                <meta name="robots" content="index, follow" />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Restaurant",
                        name: "Toppings",
                        image: "https://toppings-colon.web.app/toppings.png",
                        url: "https://toppings-colon.web.app/",
                        telephone: "+57 3132391633",
                        address: { "@type": "PostalAddress", addressLocality: "Colón", addressRegion: "Nariño", addressCountry: "CO" },
                        servesCuisine: ["Comida rápida", "Helados", "Bebidas"],
                        priceRange: "$"
                    })}
                </script>
            </Helmet>

            <Grid container justifyContent={'center'} alignItems={'center'} size={{ xs: 12, sm: 12, md: 12 }} sx={{ pt: sCell ? 13 : 15 }}>

                <Grid container size={{ xs: 12, sm: 12, md: 12 }}>
                    <Cono_Gratis textos={textos} />
                </Grid>

                <Pista_Cono/>

                {/* Título clientes */}
                <Grid container direction="column" justifyContent={'center'} alignItems={'center'} size={{ xs: 12, sm: 12, md: 12 }} sx={{ pt: 8 }}>
                    {urlsTituloClientes.length > 0 ? (
                        urlsTituloClientes.map((url, i) => (
                            <img key={i} src={url} alt="Así disfrutan nuestros clientes"
                                 style={{ width: sCell ? "100%" : 640, display: "block" }}
                                 loading="lazy"
                            />
                        ))
                    ) : (
                        <Typography component="h2" sx={{ fontSize: sCell ? 32 : 48, width: sCell ? "100%" : "70%", fontWeight: 600, fontFamily: 'Abril Fatface', textAlign: "center", color: "black" }}>
                            {textos.cono_titulo_clientes || "Así disfrutan nuestros clientes de nuestras deliciosas comidas"}
                        </Typography>
                    )}
                </Grid>

                <Grid container justifyContent={'center'} alignItems={'center'} size={{ xs: 12, sm: 12, md: 12 }} sx={{ px: 3 }}>
                    <ListaClientes />
                </Grid>
            </Grid>
        </>
    );
};

export default Seccion_Cono_Gratis;